import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import './top-menu.css'

const TopMenu = (props) => {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const updateNavbar = () => setIsScrolled(window.scrollY > 8)

    updateNavbar()
    window.addEventListener('scroll', updateNavbar, { passive: true })

    return () => window.removeEventListener('scroll', updateNavbar)
  }, [])

  return (
    <div
      className={`top-menu-thq-top-menu-elm${
        isScrolled ? ' top-menu--scrolled' : ''
      } ${props.rootClassName || ''}`}
    >
      <header
        data-thq="thq-navbar"
        className="top-menu-thq-navbar-interactive-elm"
      >
        <Link to="/" id="logo-glitch" className="top-menu-navlink10">
          <span>VLAD BUTUCARIU</span>
          <span> /</span>
        </Link>
        <Link to="/" className="top-menu-thq-logo-elm1">
          VLAD BUTUCARIU /
        </Link>
        <div
          data-thq="thq-navbar-nav"
          className="top-menu-thq-desktop-menu-elm"
        >
          <div className="top-menu-thq-logo-elm2">
            <span className="top-menu-text3">{props.text}</span>
          </div>
          <nav className="top-menu-thq-links-elm1">
            <div className="top-menu-container1">
              <Link to="/work" className="top-menu-navlink11">
                {props.text31}
              </Link>
              <Link to="/services" className="top-menu-navlink12">
                {props.text3}
              </Link>
              <Link to="/about" className="top-menu-navlink13">
                {props.text4}
              </Link>
              <Link to="/contact" className="top-menu-navlink14">
                {props.text6}
              </Link>
            </div>
          </nav>
          <div className="top-menu-thq-buttons-elm1"></div>
        </div>
        <div
          data-thq="thq-burger-menu"
          className="top-menu-thq-burger-menu-elm"
        >
          <svg viewBox="0 0 1024 1024" className="top-menu-icon1">
            <path d="M256 768v-86h512v86h-512zM512 358l-196 196-60-60 256-256 256 256-60 60z"></path>
          </svg>
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            className="top-menu-icon3"
          >
            <path
              d="m2 19.99l7.5-7.51l4 4l7.09-7.97L22 9.92l-8.5 9.56l-4-4l-6 6.01zm1.5-4.5l6-6.01l4 4L22 3.92l-1.41-1.41l-7.09 7.97l-4-4L2 13.99z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
        <div
          data-thq="thq-mobile-menu"
          className="top-menu-thq-mobile-menu-elm"
        >
          <div className="top-menu-thq-nav-elm">
            <div className="top-menu-thq-top-elm">
              <Link to="/" className="top-menu-navlink15">
                VLAD BUTUCARIU /
              </Link>
              <div
                data-thq="thq-close-menu"
                className="top-menu-thq-close-menu-elm"
              >
                <svg viewBox="0 0 1024 1024" className="top-menu-icon5">
                  <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                </svg>
              </div>
            </div>
            <nav className="top-menu-thq-links-elm2">
              <Link to="/work" className="top-menu-navlink16">
                {props.text9}
              </Link>
              <Link to="/services" className="top-menu-navlink17">
                {props.text8}
              </Link>
              <Link to="/about" className="top-menu-navlink18">
                {props.text10}
              </Link>
              <Link to="/contact" className="top-menu-navlink19">
                {props.text12}
              </Link>
            </nav>
            <div className="top-menu-thq-buttons-elm2">
              <button className="top-menu-thq-login-elm button">
                {props.login}
              </button>
              <button className="button">{props.register}</button>
            </div>
          </div>
        </div>
        <div className="top-menu-container2">
          <div className="top-menu-container3">
            <React.Fragment>
              <Script>{`
(function(){
  (function() {
  const el = document.getElementById('logo-glitch');
  const chars = '—_\\/[]{}<>=+*^?#!'; 
  
  let interval; 
  let isHovering = false;
  let scrambleCount = 0;
  
  // CONFIG: Speed of effect
  const scrambleDuration = 10; 

  el.addEventListener('mouseenter', () => {
    isHovering = true;
    scrambleCount = scrambleDuration; 
    el.style.color = "#2b00ff"; // Green on hover
    startLoop();
  });

  el.addEventListener('mouseleave', () => {
    isHovering = false;
    scrambleCount = scrambleDuration; 
    // Reset color to inherited (default logo color)
    el.style.color = "inherit"; 
    startLoop(); 
  });

  function startLoop() {
    if (interval) clearInterval(interval);
    
    interval = setInterval(() => {
      let targetText = "";
      
      // Define Targets
      if (isHovering) {
        // Easter Egg Text (Maintains the slash for consistency)
        targetText = "HOMEPAGE /"; 
      } else {
        // Default Text
        targetText = "VLAD BUTUCARIU /";
      }

      if (scrambleCount > 0) {
        // Scramble Logic
        const output = targetText.split('')
          .map((char) => {
             // Preserve space and slash logic
             if (char === ' ' || char === '/') return char; 
             return chars[Math.floor(Math.random() * chars.length)]
          })
          .join('');
        
        el.innerText = output;
        scrambleCount--;
      } else {
        // Final State
        el.innerText = targetText;
        
        if (!isHovering) {
          clearInterval(interval);
          el.style.color = "inherit"; // Ensure it goes back to default
        }
      }
    }, 40); 
  }
})();
})()
`}</Script>
            </React.Fragment>
          </div>
        </div>
      </header>
    </div>
  )
}

TopMenu.defaultProps = {
  text: 'VLAD BUTUCARIU /',
  text10: 'About',
  text9: 'Work',
  text4: 'About',
  text31: 'Work',
  text6: 'Contact',
  register: 'Register',
  text8: 'Capabilities',
  text3: 'Capabilities',
  rootClassName: '',
  text12: 'Contact',
  login: 'Login',
}

TopMenu.propTypes = {
  text: PropTypes.string,
  text10: PropTypes.string,
  text9: PropTypes.string,
  text4: PropTypes.string,
  text31: PropTypes.string,
  text6: PropTypes.string,
  register: PropTypes.string,
  text8: PropTypes.string,
  text3: PropTypes.string,
  rootClassName: PropTypes.string,
  text12: PropTypes.string,
  login: PropTypes.string,
}

export default TopMenu
